/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/18 16:10:34
 * @description: 多语言hook
 */
import type enUS from '@/i18n/en_US';
import { useI18n } from 'vue-i18n';
export type localeType = 'en_US' | 'zh_TW' | 'zh_CN' | 'id_ID';
export default () => useI18n<{ message: typeof enUS }, localeType>();
